import React from "react";
import { Formik } from "formik";
import { ReservationLoginShema } from "../../../validations/ReservationsLoginShema";
import { AuthLogin } from "../../api";
import { toast } from "react-toastify";

const ReservationLoginForm = ({
  loginFormEmail,
  loginReservationNumber,
  login,
  loginSuccess,
  checkLogin,
}) => {
  return (
    <Formik
      initialValues={{
        email: "",
        reservationNumber: "",
      }}
      validationSchema={ReservationLoginShema}
      onSubmit={(values, actions) => {
        AuthLogin(values.email, values.reservationNumber)
          .then((response) => {
            if (response.data.error) {
              localStorage.removeItem("reservations_auth");
              toast.error(response.data.error);
            } else {
              localStorage.setItem("reservations_auth", response.data.token);
              toast.success(loginSuccess);
              checkLogin();
            }
          })
          .catch((error) => {
            toast.error(error.message);
          })
          .finally(() => {
            actions.setSubmitting(false);
          });
      }}
    >
      {(props) => (
        <form className="mb-[54px] w-full" onSubmit={props.handleSubmit}>
          <div className="relative z-0 mb-[13px] w-full group">
            <input
              type="text"
              id="email"
              name="email"
              className="block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border border-[#dee9ed] appearance-none  focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
              placeholder=" "
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              value={props.values.email}
            ></input>
            <label
              htmlFor="email"
              className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form  duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3  left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
            >
              {loginFormEmail}
            </label>
          </div>
          <div className="relative z-0 mb-[13px] w-full group">
            <input
              id="reservationNumber"
              name="reservationNumber"
              className="block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border border-[#dee9ed] appearance-none  focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
              placeholder=" "
              onChange={props.handleChange}
              onBlur={props.handleBlur}
              value={props.values.reservationNumber}
            ></input>
            <label
              htmlFor="reservationNumber"
              className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form  duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3  left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
            >
              {loginReservationNumber}
            </label>
          </div>
          <button
            disabled={props.isSubmitting || !props.isValid || !props.dirty}
            type="submit"
            className="text-white md:px-[2.75rem] px-8 md:py-[1.188rem] py-3 duration-200 bg-product-type-color hover:opacity-90 focus:ring-4  font-medium rounded-lg text-sm  text-center disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {login}
          </button>
        </form>
      )}
    </Formik>
  );
};

export default ReservationLoginForm;
